/**
 * Лента «Результаты» цепочками (08.10.26): сервис уже отдаёт строки в порядке цепочек (по последнему шагу,
 * внутри — по шагам) с `chain_id`/`chain_date`/`chain_step`; здесь — только сборка групп для показа.
 * Без React/DOM — тестируется node:test.
 */

export type ChainStep = "edit" | "enhance" | "reshoot";

export const STEP_LABEL: Record<ChainStep, string> = {
  edit: "доработка",
  enhance: "улучшено",
  reshoot: "пересъёмка",
};

type Row = {
  chain_id: number;
  chain_date: string;
  generation_id: number;
  generation_cost_actual?: number | null;
  generation_cost_estimate?: number | null;
};

export type Chain<T> = {
  id: number;
  /** день и время последнего шага: по ним цепочка стоит в ленте */
  day: string;
  time: string;
  rows: T[];
  /** сумма генераций цепочки: факт, а где его ещё нет — оценка (`approx`) */
  cost: number;
  approx: boolean;
};

export function chainGroups<T extends Row>(rows: readonly T[]): Chain<T>[] {
  const out = new Map<number, Chain<T>>();
  const counted = new Set<number>();
  for (const r of rows) {
    let c = out.get(r.chain_id);
    if (!c) {
      c = { id: r.chain_id, day: r.chain_date.slice(0, 10), time: r.chain_date.slice(11, 16), rows: [], cost: 0, approx: false };
      out.set(r.chain_id, c);
    }
    c.rows.push(r);
    if (counted.has(r.generation_id)) continue; // строка на вариант — цену генерации берём один раз
    counted.add(r.generation_id);
    const actual = r.generation_cost_actual;
    if (actual === null || actual === undefined) {
      c.approx = true;
      c.cost += r.generation_cost_estimate ?? 0;
    } else {
      c.cost += actual;
    }
  }
  return [...out.values()];
}

/** Начинается ли с этой строки новый шаг цепочки (между шагами в ленте стоит стрелка). */
export const stepStarts = (rows: readonly { generation_id: number }[], i: number): boolean =>
  i > 0 && rows[i]!.generation_id !== rows[i - 1]!.generation_id;
